enum Genders {
  Validation,
  Identity,
  Other,
}

export default Genders;
